import { ChangeDetectionStrategy, Component, DestroyRef, inject, model, ViewEncapsulation } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FieldType } from '@ngx-formly/core';
import { TranslatePipe } from '@ngx-translate/core';
import { Unit } from '../../../../generated/generated-types';
import { FormlyFillHeightListHostDirective } from '../../../custom-formly/formly-tabs/formly-fill-height-list-host.directive';
import { UnitConversionConfigLinkListWidgetComponent } from '../unit-conversion-config-link-list-widget/unit-conversion-config-link-list-widget.component';

@Component({
  selector: 'app-formly-unit-conversion-config-link-list',
  imports: [UnitConversionConfigLinkListWidgetComponent, TranslatePipe],
  templateUrl: './formly-unit-conversion-config-link-list.component.html',
  styleUrl: './formly-unit-conversion-config-link-list.component.scss',
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
  hostDirectives: [FormlyFillHeightListHostDirective],
})
export class FormlyUnitConversionConfigLinkListComponent extends FieldType {

  private readonly destroyRef = inject(DestroyRef);

  vendorPriceListAddressLinkId = model<string>();
  productId = model<string>();
  productUnitConversionConfigId = model<string>();
  baseUnit = model<Unit>();
  variantParentId = model<string>();
  variantParentIdentifier = model<string>();

  constructor(
  ) {
    super();
  }

  ngOnInit(): void {
    this.syncFromProps();
    this.form?.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.syncFromProps();
    });
  }

  private syncFromProps(): void {
    const vendorPriceListAddressLinkId = this.props?.vendorPriceListAddressLinkId;
    const productId = this.props?.productId ?? this.model?.id;
    const variantParentId = this.props?.variantParentId;
    const variantParentIdentifier = this.props?.variantParentIdentifier;
    const baseUnit = this.props?.baseUnit;

    if (vendorPriceListAddressLinkId) {
      this.vendorPriceListAddressLinkId.set(vendorPriceListAddressLinkId);
    }
    this.productId.set(productId || undefined);
    if (baseUnit) {
      this.baseUnit.set(baseUnit);
    }
    if (variantParentId) {
      this.variantParentId.set(variantParentId);
    }
    if (variantParentIdentifier) {
      this.variantParentIdentifier.set(variantParentIdentifier);
    }
  }

}